import { render, staticRenderFns } from "./examen-para-modal.html?vue&type=template&id=028b62ed&scoped=true&external"
import script from "./examen-para-modal.js?vue&type=script&lang=js&external"
export * from "./examen-para-modal.js?vue&type=script&lang=js&external"
import style0 from "./examen-para-modal.scss?vue&type=style&index=0&id=028b62ed&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028b62ed",
  null
  
)

export default component.exports